<template>
  <div>
    <div class="problem-body">
      <div class="nb">
        <personal-info-sidebar />
        
        <div class="problem-rside">
          <div class="probar">
            <a href="#">{{ $t('personalInfo.title') }}</a>
          </div>
          <div class="problemcon problistpad">
            <ul>
              <li>
                <label>{{ $t('personalInfo.username') }}：</label>
                <el-input 
                  type="text" 
                  v-model="userInfo.name" 
                  maxlength="20" 
                  class="s-length"
                  :placeholder="$t('personalInfo.usernamePlaceholder')">
                </el-input>
              </li>
              <li>
                <label>{{ $t('personalInfo.phone') }}：</label>
                <el-input 
                  type="text" 
                  v-model="userInfo.tel" 
                  maxlength="11" 
                  class="s-length"
                  :placeholder="$t('personalInfo.phonePlaceholder')">
                </el-input>
              </li>
            </ul>
            <el-button 
              type="primary" 
              class="btn-save" 
              @click="savePersonalInfo">
              {{ $t('personalInfo.saveBtn') }}
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { getUserInfo, updateUserInfo } from '@/api/platform/personalInfo/personalInfoApi'
import PersonalInfoSidebar from '@/components/platform/personalInfo/personalInfoSidebar.vue'

export default {
  name: 'PersonalInfo',
  components: {
    PersonalInfoSidebar
  },
  data() {
    return {
      userInfo: {},
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(this.shopId)
    this.initPersonalInfo()
  },
  methods: {
    async initPersonalInfo() {
      try {
        const userInfo = this.$store.getters.userInfo
        if (userInfo) {
          const params = {
            page: 1,
            row: 1,
            userId: userInfo.userId
          }
          const res = await getUserInfo(params)
          this.userInfo = res.data[0]
        }
      } catch (error) {
        console.error('获取个人信息失败:', error)
      }
    },
    async savePersonalInfo() {
      if (!this.updateUserValidate()) {
        this.$message.error(this.validate.errInfo)
        return
      }
      
      try {
        const res = await updateUserInfo(this.userInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('personalInfo.saveSuccess'))
          return
        }
        this.$message.error(res.msg)
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error(this.$t('personalInfo.saveError'))
      }
    },
    updateUserValidate() {
      const rules = {
        tel: [
          { required: true, message: this.$t('personalInfo.phoneRequired'), trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: this.$t('personalInfo.phoneFormat'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('personalInfo.usernameRequired'), trigger: 'blur' }
        ],
        userId: [
          { required: true, message: this.$t('personalInfo.userIdRequired'), trigger: 'blur' }
        ]
      }
      
      const validator = new this.$validator(this.userInfo, rules)
      if (validator.passes()) {
        return true
      } else {
        this.validate = validator
        return false
      }
    }
  }
}
</script>

<style scoped>
.problem-body {
  width: 100%;
}
.nb {
  display: flex;
}
.problem-rside {
  flex: 1;
  padding-left: 20px;
}
.probar {
  margin-bottom: 20px;
}
.problemcon {
  background: #fff;
  padding: 20px;
}
.problemcon ul li {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}
.problemcon ul li label {
  width: 100px;
  text-align: right;
  margin-right: 10px;
}
.s-length {
  width: 300px;
}
.btn-save {
  margin-top: 20px;
  margin-left: 110px;
}
</style>